export default __webpack_public_path__ + "static/media/masthead.d3377a10.png";